import React, { useState, useEffect} from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { getItems, selectItem, sendItemNote, saveItemAttributes } from "../../redux/actions/machineActions.js";
import moment from 'moment';
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
  CustomInput
} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from "react-bootstrap-table2-paginator";

import Timeline from "../../components/Timeline";
import TimelineItem from "../../components/TimelineItem";

import { MoreHorizontal } from "react-feather";


const { SearchBar } = Search




const MachineList = ({machine, getItems, selectItem, sendItemNote, saveItemAttributes}) => {
  useEffect(() => {
      getItems();
    }, [getItems]);

// Note State
const[note, setNote] = useState({
  pairedId: '',
  note: '',
  dateCreated: moment().format("YYYY-MM-DD"),
})
const updateNote = e => setNote({...note, [e.target.name]: e.target.value});
const setFile = e => setNote({...note, file: e.target.files[0]})
const sendNote = () => {
  note.pairedId = machine.selectItem._id;
  sendItemNote(note);
  setNote({
    pairedId: '',
    note: '',
    dateCreated: moment().format("YYYY-MM-DD"),
  })
}

//Select Item
const [toggleSwitch, setToggleSwitch] = useState({
  toggle: false,
  message: 'Edit'
})
const updateToggleSwitch = e => {
  let value = e.target.checked;
  console.log(e.target)
  if(value === true){
    setMirror(machine.selectItem.attributes)
    setToggleSwitch({...toggleSwitch, toggle: true, message: 'Click to Save'})
  }
  if(value === false){
    saveItemAttributes(newAttributes, mirror, machine.selectItem)
    setToggleSwitch({...toggleSwitch, toggle: false, message: 'Edit'})
    setNewAttributes({
      name: '',
      value: ''
    })
  }

}

//Mirror of SELECT_ITEM
const [mirror, setMirror] = useState({})
const updateMirror = e => setMirror({...mirror, [e.target.name]: e.target.value})

const [newAttributes, setNewAttributes] = useState({
  name: '',
  value: ''
})

const updateNewAttributes = e => setNewAttributes({...newAttributes, [e.target.name]: e.target.value})

const tableColumns = [
  {
    dataField:"category",
    text: "Category",
    sort: true
  },
  {
    dataField:"label",
    text: "Name",
    sort: true
  }
]
const selectRow = {
  mode: 'checkbox',
  clickToSelect: true,
  hideSelectColumn: true,
  onSelect: (row, isSelect, rowIndex, e) => {
    selectItem(row)
  }
}

  const List = () => (
      <Card>
        <CardHeader>
          <div className="card-actions float-right">
            <UncontrolledDropdown>
              <DropdownToggle tag="a">
                <MoreHorizontal />
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another Action</DropdownItem>
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <CardTitle tag="h5" className="mb-0">
            Machines
          </CardTitle>
        </CardHeader>
        <CardBody>
            <ToolkitProvider
              keyField="_id"
              data={ machine.items }
              columns={ tableColumns }
              search
            >
              {
                props => (
                  <div>
                    <SearchBar { ...props.searchProps } />
                    <BootstrapTable
                      { ...props.baseProps }
                      bootstrap4
                      striped
                      hover
                      pagination={paginationFactory({
                        sizePerPage: 5,
                        sizePerPageList: [5, 10, 25, 50]
                      })}
                      selectRow = {selectRow}
                    />
                  </div>
                )
              }
            </ToolkitProvider>
        </CardBody>
      </Card>
    );
  const Feed = () => (
    <Card>
        <CardHeader>
          <div className="card-actions float-right">
            <UncontrolledDropdown>
              <DropdownToggle tag="a">
                <MoreHorizontal />
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another Action</DropdownItem>
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <CardTitle tag="h5" className="mb-0">
            {machine.selectItem.label}
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Timeline className="mt-2">
            {(machine.selectItem.notes) && machine.selectItem.notes.map((item, index) =>
              <TimelineItem key={index}>
                <strong>{moment.utc(item.dateCreated).format("MM-DD-YYYY")}</strong>
                <span className="float-right text-muted text-sm">{moment.utc(item.dateCreated).fromNow()}</span>
                <p>{item.note}</p>
                {(item.img === true) &&
                  <Row noGutters className="mt-1">
                    <Col xs="12">
                      <img src={`/api/items/image/${item.filename}`} className="img-fluid pr-1" alt="Unsplash" />
                    </Col>
                  </Row>
                }
              </TimelineItem>
            )}
          </Timeline>
        </CardBody>
    </Card>

  )

const theSwitch =() => {
  switch(machine.switch){
    case true:
      return (
        <>
          <Row>
            <Col xl="5">
              <List />
            </Col>
            <Col xl="7">
              <Card>
                  <CardHeader>
                    <div className="card-actions float-right">
                      <CustomInput
                        type="switch"
                        id="exampleCustomSwitch"
                        name="toggle"
                        checked={toggleSwitch.toggle}
                        value={toggleSwitch.toggle}
                        onChange={(e) => updateToggleSwitch(e)}
                        label={toggleSwitch.message}
                      />
                    </div>
                    <CardTitle tag="h5" className="mb-0">
                      {machine.selectItem.label}
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Table size="sm" className="my-2">
                      <tbody>
                        <tr>
                          <td>Category</td>
                          <td>{machine.selectItem.category}</td>
                        </tr>
                        {(!toggleSwitch.toggle) &&
                        Object.keys(machine.selectItem.attributes).map((keyName, index) => (
                            <tr key={index}>
                              <th>{keyName}</th>
                              <td>{machine.selectItem.attributes[keyName]}</td>
                            </tr>
                        ))}
                        {(toggleSwitch.toggle) &&
                        Object.keys(mirror).map((keyName, index) => (
                            <tr key={index}>
                              <th>{keyName}</th>
                              <td>
                                <Input
                                  name={keyName}
                                  value={mirror[keyName]}
                                  onChange={(e) => updateMirror(e)}
                                  /></td>
                            </tr>
                        ))
                      }
                      {(toggleSwitch.toggle) &&
                        <tr>
                          <th>
                            <Input
                              name="name"
                              placeholder="New Category Name"
                              value={newAttributes.name}
                              onChange={(e) => updateNewAttributes(e)}
                              />
                          </th>
                          <td>
                            <Input
                              name="value"
                              placeholder="New Value"
                              value={newAttributes.value}
                              onChange={(e) => updateNewAttributes(e)}
                              />
                          </td>
                        </tr>
                      }
                      </tbody>
                    </Table>
                    <hr />
                    <Col lg="12">
                      <Form>
                        <FormGroup row>
                          <Label sm={3} className="text-sm-left">
                            Date:
                          </Label>
                          <Col sm={9}>
                            <Input type="date" name="dateCreated"  value={note.dateCreated} onChange={(e) => updateNote(e)} required/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label sm={3} className="text-sm-left">
                            Note:
                          </Label>
                          <Col sm={9}>
                            <Input
                              key="form1"
                              type="textarea"
                              name="note"
                              placeholder="Add a note"
                              rows="3"
                              value={note.note}
                              onChange={(e) => updateNote(e)}
                              required
                            />
                          </Col>
                        </FormGroup>  <FormGroup row>
                            <Label sm={3} className="text-sm-left">
                            </Label>
                            <Col sm={9}>
                              <Input
                                type="file"
                                name="note"
                                onChange={(e) => setFile(e)}
                                required
                              />
                            </Col>
                          </FormGroup>
                        <FormGroup row>
                          <Col sm={{ size: 10, offset: 2 }}>
                            <Button color="primary" onClick={() => sendNote()}>Submit</Button>
                          </Col>
                        </FormGroup>
                      </Form>
                    </Col>

                  </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl ="12">
              <Feed/>
            </Col>
          </Row>
        </>
      )
    default:
      return(
        <Row>
          <Col xl="12">
            <List />
          </Col>
        </Row>
      )
  }
}

  return (
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Maintenance/Machines</h1>
        {theSwitch()}
      </Container>
    );
}
const mapStateToProps = state => ({
  machine: state.machine
})

export default connect(mapStateToProps, {saveItemAttributes,getItems, selectItem, sendItemNote})(MachineList);
